import type { TitleProps } from '@mantine/core'

export const walmartTitleProps = {
    pageTitle: {
        fz: 'var(--gm-display-s-font-size)',
        lh: 'var(--gm-display-s-line-height)',
        fw: 700,
    },
    section: {
        fz: 'var(--gm-text-l-font-size)',
        fw: 700,
        c: 'var(--gm-foreground-fg-primary)',
    },
} as const satisfies Record<string, Partial<TitleProps>>

const LINE_HEIGHT_BY_SIZE: Record<string, string> = {
    '12': 'var(--gm-text-xs-line-height)',
    '14': 'var(--gm-text-s-line-height)',
    '16': 'var(--gm-text-m-line-height)',
    '18': 'var(--gm-text-l-line-height)',
    '20': 'var(--gm-text-xl-line-height)',
    '24': 'var(--gm-text-2xl-line-height)',
    '28': 'var(--gm-display-s-line-height)',
}

const SIZE_KEYS: Record<string, string> = {
    xs: '12',
    sm: '14',
    md: '16',
    lg: '18',
    xl: '20',
    '2xl': '24',
    'var(--gm-text-xs-font-size)': '12',
    'var(--gm-text-s-font-size)': '14',
    'var(--gm-text-m-font-size)': '16',
    'var(--gm-text-l-font-size)': '18',
    'var(--gm-text-xl-font-size)': '20',
    'var(--gm-text-2xl-font-size)': '24',
    'var(--gm-display-s-font-size)': '28',
}

export function lineHeightForSize(fz: unknown): string | undefined {
    if (typeof fz === 'number') return LINE_HEIGHT_BY_SIZE[String(fz)]
    if (typeof fz !== 'string') return undefined
    const key = SIZE_KEYS[fz] ?? fz.replace(/px$/, '')
    return LINE_HEIGHT_BY_SIZE[key]
}
